import { render, staticRenderFns } from "./JtChartCard.vue?vue&type=template&id=354926ca&scoped=true"
import script from "./JtChartCard.vue?vue&type=script&lang=js"
export * from "./JtChartCard.vue?vue&type=script&lang=js"
import style0 from "./JtChartCard.vue?vue&type=style&index=0&id=354926ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354926ca",
  null
  
)

export default component.exports